export const CAPI_GA4_MEASUREMENT_ID = 'G-JTNTG71F81';
